import script from "./ManageAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageAddress.vue?vue&type=script&setup=true&lang=js"

import "./ManageAddress.vue?vue&type=style&index=0&id=3fab4542&lang=css"

const __exports__ = script;

export default __exports__